import { render, staticRenderFns } from "./siteType.vue?vue&type=template&id=24b65065&scoped=true&"
import script from "./siteType.vue?vue&type=script&lang=js&"
export * from "./siteType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b65065",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b65065')) {
      api.createRecord('24b65065', component.options)
    } else {
      api.reload('24b65065', component.options)
    }
    module.hot.accept("./siteType.vue?vue&type=template&id=24b65065&scoped=true&", function () {
      api.rerender('24b65065', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Site/siteType/siteType.vue"
export default component.exports